export const SupervisionPeriod = {
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
};
